import { useLocation, Navigate } from 'react-router-dom';
import { isAuthenticated } from '../services/storage';

function PublicRoute({ children }) {
  const location = useLocation();

  if (isAuthenticated()) {
    return <Navigate to="/devices" state={{ from: location }} />;
  }

  return children;
}

export default PublicRoute;
